import { css } from 'lit';

export const AccountSwitcherStyles = css`
  #account-switcher-dialog {
    position: relative;
    z-index: var(--ix-account-switcher-z-index, 50);
  }
  .subaccount-wrap {
    background: var(--clr-surface-container-lowest, #fff);
    display: flex;
    border-radius: 5px;
    --ix-icon-font-size: 1.6rem;
  }
  .subaccount-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 0;
    flex: 1;
  }
  .dd-icon {
    margin: -2px -5px -5px 0px;
  }
  .headline {
    display: flex;
  }
  .title {
    flex: 1;
    font-size: 1.25rem;
    line-height: 24px;
    font-family: var(--root-secondary-font, 'Red Hat Display', 'sans-serif');
    font-weight: 700;
  }
  #account-switcher-dialog-form {
    padding: 8px 24px;
  }
  #accountTree {
    overflow: auto;
    border: 1px solid #e0e0e0;
    border-radius: 0.25rem;
    height: 50vh;
    margin: 1rem 0;
    padding: 0;
    width: 512px;
  }

  #loadMore,
  #loadPrevious {
    display: flex;
    justify-content: center;
    padding: 0.5rem;
    --md-circular-progress-size: 40px;
  }
  ix-textbox {
    --md-filled-text-field-top-space: 6px;
    --md-filled-text-field-bottom-space: 6px;
    --md-filled-text-field-container-color: rgba(245, 247, 255, 1);
    --md-filled-field-hover-state-layer-opacity: 0;
    --md-filled-field-hover-state-layer-opacity: 0;
    --md-filled-field-leading-content-color: rgba(9, 34, 65, 1);
    --md-filled-text-field-container-shape-end-end: 4px;
    --md-filled-text-field-container-shape-end-start: 4px;
    --md-filled-text-field-focus-active-indicator-height: 0px;
    --md-filled-text-field-hover-active-indicator-height: 0px;
    --md-filled-text-field-active-indicator-height: 0px;
    --ix-icon-color: rgba(9, 34, 65, 1);
    --md-filled-text-field-input-text-placeholder-color: rgba(9, 34, 65, 0.7);
    --md-filled-text-field-input-text-size: 0.875rem;
  }

  .account-filter {
    cursor: pointer;
    padding: 2px;
  }
  .account-filter:hover {
    text-decoration: underline;
  }
  .account-filter.active {
    text-decoration: underline;
    font-weight: bold;
  }
  .padded-container {
    padding: 12px;
  }
  .loading-container,
  .loading-container-switch {
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;
  }
  .loading-container-switch {
    min-height: 300px;
  }
  .stick-to-top {
    position: sticky;
    top: 0;
    background-color: rgb(200, 223, 250);
    z-index: 1;
  }

  .no-results {
    padding: 12px 0 0 24px;
    margin: 0;
    font-size: 14px;
    line-height: 24px;
    color: rgba(9, 34, 65, 0.7);
  }
  @media only screen and (max-width: 600px) {
    :host {
      --md-outlined-field-container-shape: 0px;
    }

    .subaccount-wrap {
      border-radius: 0;
    }

    #accountTree {
      max-width: 100%;
    }
  }
`;
